import React from "react";
import { css } from "emotion";
import { defaultStyle } from "./style";
import DynamicRange from "../../molecules/DynamicRange";
import { intFormat, formatCurrency } from "../../../../shared/create-offer/utils/formats";
import { isMobile } from "../../../../../js/components/searchform/utils/common";
import { getStartAverage } from "../../../shared/utils";

export const BlackFridayRange = props => {
	const {
		price,
		averageMiles,
		startAverage,
		endAverage,
		countAllowedSales,
		quantMiles,
		minCPFs,
		mobile
	} = props;

	let maxSales = parseInt(quantMiles / averageMiles);
	if (maxSales > countAllowedSales) {
		maxSales = countAllowedSales;
	}

	let minAverage = getStartAverage(quantMiles, countAllowedSales, startAverage, endAverage);

	const validAverage = averageMiles >= minAverage && averageMiles <= endAverage;
	const possibleBonus = minAverage <= endAverage && countAllowedSales >= minCPFs;

	return (
		<div
			className={css`
				${defaultStyle(mobile)}
			`}
		>
			<header>
				{possibleBonus ? (
					<>
						Aproveite o bônus<span>Aproveite</span>
					</>
				) : (
					<>
						BÔNUS <span>Aproveite</span>
					</>
				)}
			</header>
			{possibleBonus && (
				<DynamicRange
					{...props}
					startAverage={minAverage}
					textRange={
						<>
							Arraste o ponteiro e defina a média entre {intFormat(minAverage)} e{" "}
							{intFormat(endAverage)} para ganhar R$ {formatCurrency(price)} a mais em cada emissão
							feita para passageiros diferentes.
						</>
					}
				/>
			)}
			<footer style={!possibleBonus ? { marginTop: "-30px" } : {}}>
				{validAverage ? (
					<p className="align-center p-0">
						Seu bônus das milhas:{" "}
						<strong className="align-center">
							R$ <span>{formatCurrency(maxSales * price)}</span>
						</strong>
					</p>
				) : possibleBonus ? (
					<p className="align-center p-0">Esta média não está elegível ao bônus.</p>
				) : (
					<p className="align-center p-0">Esta oferta não está elegível ao bônus.</p>
				)}
				<p className="align-center m-0">
					{!possibleBonus ? "Quer participar da campanha? " : ""}Acesse o{" "}
					<a href="/regulamento-campanha-extra-bonus" target={isMobile() ? "_self" : "_target"}>
						Regulamento.
					</a>
				</p>
			</footer>
		</div>
	);
};

export default BlackFridayRange;
